export const RETURNING_USER_KEY = 'returning-user';
export const BRITE_AUTH_SESSION_KEY = 'brite-auth-session';

/**
 * Checks if the user is a returning customer.
 */
export function isReturningUser() {
    try {
        return !!window.localStorage.getItem(RETURNING_USER_KEY);
    } catch {
        return true;
    }
}
